import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { denormalize } from 'normalizr';
import 'react-table/react-table.css';
import { translate } from 'react-i18next';
import CommonTable from '../components/CommonTable';
import TextFilterField from '../components/filters/TextFilterField';
import DateRangeFilterField from '../components/filters/DateRangeFilterField';
import { dateFromISO } from '../utils/helpers';
import { getCollectionRequestData } from '../utils/react-table-helpers';
import * as alertActions from '../redux/modules/alerts';
import i18n from '../translations/i18n';

const propTypes = {
  t: PropTypes.func,
  fetchAlerts: PropTypes.func,
  result: PropTypes.any,
  loading: PropTypes.any,
  alerts: PropTypes.any,
};

class AlertList extends React.Component {
  constructor(props) {
    super(props);

    this.initColumns();
    this.state = {
      pageSize: 10,
      totalPages: -1,
      timeout: null,
    };

    this.defaultSorting = [
      {
        id: 'date_created',
        desc: true,
      },
    ];
    this.alertTypeFilter = { id: 'alert_type___name', value: 'Battery level' };
    this.fetchData = this.fetchData.bind(this);
  }

  initColumns() {
    this.columns = [
      {
        header: this.props.t('first_name'),
        accessor: 'paketbox___owner___first_name',
        filterMethod: (filter, row) =>
          row.first_name.toLowerCase().startsWith(filter.value.toLowerCase()),
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="first_name" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
      {
        header: this.props.t('last_name'),
        accessor: 'paketbox___owner___last_name',
        filterMethod: (filter, row) =>
          row.last_name.toLowerCase().startsWith(filter.value.toLowerCase()),
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="last_name" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
      /*
          -- Address --
       */
      {
        header: this.props.t('street'),
        accessor: 'paketbox___street',
        filterMethod: (filter, row) =>
          row.street.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0,
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="street" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
      {
        header: this.props.t('number'),
        accessor: 'paketbox___street_number',
        filterMethod: (filter, row) =>
          row.street_number.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0,
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="street_number" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
      {
        header: this.props.t('postal_code'),
        accessor: 'paketbox___postal_code',
        filterMethod: (filter, row) =>
          row.place.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0,
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="postal_code" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
      {
        header: this.props.t('place'),
        accessor: 'paketbox___place',
        filterMethod: (filter, row) =>
          row.place.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0,
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="place" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
      /*
          -- Address END --
       */
      // {
      //   header: this.props.t('id'),
      //   accessor: 'id',
      //   className: 'centerAlign',
      //   width: 60,
      //   filterRender: ({ filter, onFilterChange }) => (
      //     <TextFilterField
      //       type="number" name="id" filter={filter} onFilterChange={onFilterChange}
      //     />
      //   ),
      //   apiRequest: {
      //     filterTransform: value => (parseInt(value, 10)),
      //     operator: 'eq',
      //   },
      // },
      // {
      //   header: this.props.t('paketbox_id'),
      //   accessor: 'paketbox_id',
      //   className: 'centerAlign',
      //   width: 60,
      //   filterRender: ({ filter, onFilterChange }) => (
      //     <TextFilterField type="number" name="paketbox_id" filter={filter} onFilterChange={onFilterChange} />
      //   ),
      //   apiRequest: {
      //     filterTransform: value => (parseInt(value, 10)),
      //     operator: 'eq',
      //   },
      // },
      // {
      //   header: this.props.t('paketbox_name'),
      //   accessor: 'paketbox___name',
      //   filterRender: ({ filter, onFilterChange }) => (
      //     <TextFilterField name="paketbox___name" filter={filter} onFilterChange={onFilterChange} />
      //   ),
      // },
      {
        header: this.props.t('alert_type'),
        accessor: 'alert_type___name',
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField
            name="alert_type___name"
            filter={this.alertTypeFilter}
            onFilterChange={onFilterChange}
            disabled
          />
        ),
      },
      // {
      //   header: this.props.t('message'),
      //   accessor: 'text',
      //   filterRender: ({ filter, onFilterChange }) => (
      //     <TextFilterField name="text" filter={filter} onFilterChange={onFilterChange} />
      //   ),
      // },
      {
        header: this.props.t('created'),
        accessor: 'date_created',
        render: row => dateFromISO(row.value),
        filterRender: ({ filter, onFilterChange }) => (
          <DateRangeFilterField
            name="date_created"
            filter={filter}
            onFilterChange={onFilterChange}
          />
        ),
        apiRequest: {
          betweenDates: true,
        },
      },
    ];
  }

  fetchData(state) {
    // if (!state.filtering.includes(this.alertTypeFilter)) {
    //   state.filtering.push(this.alertTypeFilter);
    // }

    const request = getCollectionRequestData(state);
    this.setState({ pageSize: state.pageSize });

    clearTimeout(this.state.timeout);
    const timeout = setTimeout(() => {
      this.props.fetchAlerts(request);
    }, 300);

    this.setState({ timeout });
  }

  render() {
    let data = [];

    if (this.props.result.data && this.props.result.data.length > 0) {
      const denormalized = denormalize(
        this.props.result,
        { data: [alertActions.alertSchema] },
        { alerts: this.props.alerts }
      );
      data = denormalized.data;
    }

    let totalPages = -1;
    if (this.props.result.total) {
      totalPages = Math.ceil(this.props.result.total / this.state.pageSize);
    }

    return (
      <CommonTable
        defaultFiltering={[this.alertTypeFilter]}
        title={this.props.t('alert_list')}
        data={data}
        pages={totalPages}
        manual
        defaultSorting={this.defaultSorting}
        onChange={this.fetchData}
        loading={this.props.loading}
        columns={this.columns}
      />
    );
  }
}

AlertList.propTypes = propTypes;
AlertList.defaultProps = {
  result: {},
};

function mapStateToProps(state) {
  return {
    loading: state.alerts.fetching,
    alerts: state.alerts.entities,
    result: state.alerts.result,
  };
}

const extended = translate(['translations'], { i18n })(AlertList);
export default connect(mapStateToProps, alertActions)(extended);



// WEBPACK FOOTER //
// ./src/containers/AlertList.js